module.exports = __webpack_public_path__ + "static/media/averta.8317433b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta.woff
// module id = 842
// module chunks = 4